import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const ConfirmationApproveModel = ({ show, handleClose, handleConfirm }) => {
  const [paymentMethod, setPaymentMethod] = useState('');

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
  };

  const handleApprove = () => {
    if (paymentMethod) {
      handleConfirm(paymentMethod);
    }
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Are you sure you want to Approve?</p>
        <Form>
          <Form.Check
            type="radio"
            id="upi"
            label="UPI"
            name="paymentMethod"
            value="UPI"
            checked={paymentMethod === 'UPI'}
            onChange={handlePaymentMethodChange}
          />
          <Form.Check
            type="radio"
            id="bankTransfer"
            label="Bank Transfer"
            name="paymentMethod"
            value="Bank Transfer"
            checked={paymentMethod === 'Bank Transfer'}
            onChange={handlePaymentMethodChange}
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="success"
          onClick={handleApprove}
          disabled={!paymentMethod}
        >
          Approve
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationApproveModel;
